(function () {
    'use strict';

    angular
        .module('app')
        .value('apiBaseUrl', '') // application root, src subfolder, or absolute like 'http://server/api/'
        .value('configBaseLayers', function configBaseLayersFactory() {
            return {
                baselayers: {
                    osm: {
                        name: 'OpenStreetMap',
                        type: 'xyz',
                        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        layerOptions: {
                            subdomains: ['a', 'b', 'c'],
                            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                            continiousWorld: false,
                            minZoom: 2
                        }
                    } //,
                    //google_standard: {
                    //    name: 'Google Standard',
                    //    type: 'xyz',
                    //    url: 'https://mt.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                    //    layerOptions: {
                    //        attribution: 'Map data &copy; Google',
                    //        minZoom: 2
                    //    }
                    //},
                    //google_hybrid: {
                    //    name: 'Google Hybrid',
                    //    type: 'xyz',
                    //    url: 'https://mt.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                    //    layerOptions: {
                    //        attribution: 'Map data &copy; Google, DigitalGlobe',
                    //        minZoom: 2
                    //    }
                    //}
                }
            };
        })            
        .value('configHistoryLayers', function configHistoryLayersFactory(ecaGeoJson) {
            return {
                overlays: {
                    seamarks: {
                        name: 'Sea Marks',
                        type: 'xyz',
                        url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.75,
                            attribution: '&copy; <a href="http://www.openseamap.org">OpenSeaMap</a>',
                            minZoom: 8,
                            visible: true
                        }
                    },
                    eca: {
                        name: 'Emission Control Area',
                        type: 'geoJSONShape',
                        data: ecaGeoJson,
                        layerOptions: {
                            style: {
                                color: 'red',
                                weight: 2.0,
                                opacity: 0.6,
                                fillOpacity: 0.2
                            },
                            visible: true
                        }
                    },

                    harbours: {
                        name: 'Harbours',
                        type: 'group',
                        visible: false
                    },

                    vessels: {
                        name: 'Vessels',
                        type: 'group',
                        visible: true
                    }
                }
            };
        })
        .value('configLayers', function configLayersFactory(openweathermapKey, ecaGeoJson) { // ecaGeoJson - emission control json - static - does not change, assign once
            var openPortGuideAttribution = '&copy; weather.openportguide.de<a title="openportguide.de" href="http://openportguide.com/index.php/" target="_blank"><img src="http://openportguide.com/images/OpenPortGuideLogo_32.png" alt=""></a>';
            var openweathermapAttribution = '&copy; <a href="http://www.openweathermap.com">OpenWeatherMap</a>';
            return {
                overlays: {
                    seamarks: {
                        name: 'Sea Marks',
                        type: 'xyz',
                        url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.75,
                            attribution: '&copy; <a href="http://www.openseamap.org">OpenSeaMap</a>',
                            minZoom: 8
                        }
                    },
                    eca: {
                        name: 'Emission Control Area',
                        type: 'geoJSONShape',
                        data: ecaGeoJson,
                        layerOptions: {
                            style: {
                                color: 'red',
                                weight: 2.0,
                                opacity: 0.6,
                                fillOpacity: 0.2
                            }
                        }
                    },
                    weather: {
                        name: 'Weather (A)',
                        type: 'group',
                        layerOptions: {
                            attribution: openweathermapAttribution,
                            apiKey: openweathermapKey
                        }
                    },
                    clouds: {
                        name: 'Clouds (A)',
                        type: 'xyz',
                        url: 'https://tile.openweathermap.org/map/clouds_new/{z}/{x}/{y}.png?appid={apiKey}',
                        layerOptions: {
                            format: 'image/png',
                            opacity: 1,
                            attribution: openweathermapAttribution,
                            apiKey: openweathermapKey
                        }
                    },

                    precipitationForecasts: {
                        name: 'Precipitation (A)',
                        type: 'xyz',
                        url: 'https://tile.openweathermap.org/map/precipitation_new/{z}/{x}/{y}.png?appid={apiKey}',
                        layerOptions: {
                            format: 'image/png',
                            opacity: 1,
                            attribution: openweathermapAttribution,
                            apiKey: openweathermapKey
                        }
                    },

                    windSpeed: {
                        name: 'Wind speed (A)',
                        type: 'xyz',
                        url: 'https://tile.openweathermap.org/map/wind_new/{z}/{x}/{y}.png?appid={apiKey}',
                        layerOptions: {
                            format: 'image/png',
                            opacity: 1,
                            attribution: openweathermapAttribution,
                            apiKey: openweathermapKey
                        }
                    },

                    windStream: {
                        name: 'Wind stream (F)',
                        type: 'xyz',
                        url: 'https://weather.openportguide.de/tiles/actual/wind_vector/{timeStep}h/{z}/{x}/{y}.png',
                        doRefresh: false,
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.5,
                            attribution: openPortGuideAttribution,
                            maxZoom: 7,
                            timeStep: 0
                        }
                    },

                    windBarb: {
                        name: 'Wind barb (F)',
                        type: 'xyz',
                        url: 'https://weather.openportguide.de/tiles/actual/wind_barb/{timeStep}h/{z}/{x}/{y}.png',
                        doRefresh: false,
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.5,
                            attribution: openPortGuideAttribution,
                            maxZoom: 7,
                            timeStep: 0
                        }
                    },

                    surfacePressure: {
                        name: 'Surface pressure (F)',
                        type: 'xyz',
                        url: 'https://weather.openportguide.de/tiles/actual/surface_pressure/{timeStep}h/{z}/{x}/{y}.png',
                        doRefresh: false,
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.5,
                            attribution: openPortGuideAttribution,
                            maxZoom: 7,
                            timeStep: 0
                        }
                    },

                    airTemperature: {
                        name: 'Air Temperature (F)',
                        type: 'xyz',
                        url: 'https://weather.openportguide.de/tiles/actual/air_temperature/{timeStep}h/{z}/{x}/{y}.png',
                        doRefresh: false,
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.5,
                            attribution: openPortGuideAttribution,
                            maxZoom: 7,
                            timeStep: 0
                        }
                    },

                    precipitation: {
                        name: 'Precipitation (F)',
                        type: 'xyz',
                        url: 'https://weather.openportguide.de/tiles/actual/precipitation/{timeStep}h/{z}/{x}/{y}.png',
                        doRefresh: false,
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.5,
                            attribution: openPortGuideAttribution,
                            maxZoom: 7,
                            timeStep: 0
                        }
                    },

                    significantWaveHeight: {
                        name: 'Significant wave height (F)',
                        type: 'xyz',
                        url: 'https://weather.openportguide.de/tiles/actual/significant_wave_height/{timeStep}h/{z}/{x}/{y}.png',
                        doRefresh: false,
                        layerOptions: {
                            format: 'image/png',
                            opacity: 0.5,
                            attribution: openPortGuideAttribution,
                            maxZoom: 7,
                            timeStep: 0
                        }
                    },

                    harbours: {
                        name: 'Harbours',
                        type: 'group'
                    },

                    vessels: {
                        name: 'Vessels',
                        type: 'group'
                    }
                }
            };
        });
})();


// WEBPACK FOOTER //
// ./src/app.config.js